import { rebindContainer } from '@/config/configurator/rebind-container.configurator';
import { registerComponents } from '@/config/configurator/register-components.configurator';
import { Components, ConfiguratorOptions, SUBMODULES_PATHS } from '@empathybroker/ebx-gluon';
import { mapGetters } from 'vuex';

export const customConfiguratorOptions = (configuratorOptions: ConfiguratorOptions) => {
  Components.Smart.ResultsGrid.mixin({
    computed: {
      ...mapGetters(SUBMODULES_PATHS.search, { gridItems: 'gridItemsWithBlogPosts' })
    }
  });
  registerComponents();
  rebindContainer(configuratorOptions);
};

